var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocuments = function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#documents_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.728 12.815h20.544s.978 0 .978.978v8.479s0 .978-.978.978H1.728s-.978 0-.978-.979v-8.478s0-.978.978-.978M2.25 12.814V6.977A.983.983 0 0 1 3.237 6h8.388a.99.99 0 0 1 .789.392L13.6 8.248h6.414a.983.983 0 0 1 .986.979v3.587M9.065 15.748h5.87M19.737 5.248v-1.27A.983.983 0 0 0 18.75 3H13.6l-1.186-1.86a.99.99 0 0 0-.79-.392H4.5a.983.983 0 0 0-.987.98V2.77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "documents_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgDocuments;